import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { saveReturnUrl } from 'src/app/common/returnUrlUtils';
import { Labels } from 'src/app/labels/englishLabels';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';
import {
  DialogLayoutDisplay,
  ToastNotificationInitializer,
  ToastPositionEnum,
  ToastProgressBarEnum,
} from '@costlydeveloper/ngx-awesome-popup';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  // Static flag to prevent logout when user has no access groups (403 received)
  public static hasAccessRestriction = false;

  constructor(
    private readonly _logger: LoggerService,
    private readonly _auth: AuthService,
    private readonly _router: Router,
    private readonly _notificationsService: NotificationsService
  ) {}

  /**
   * Error interceptor
   * This will intercept each http response.
   * On each response it will check for errors and log the error.
   * It will handle specific status codes:
   *  401: Will logout the user and redirect the user to the login page.
   *  403: Will show access restricted notification (user has no access groups)
   *  etc
   */
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ErrorEvent) {
          this._logger.warn(`Got a client side error when calling this is client side error when calling
                     '${error.url} with headers ${JSON.stringify(error.headers)} - error message ${error.message}`);
        } else {
          switch (error.status) {
            case 401:
              if (!HttpErrorInterceptor.hasAccessRestriction) {
                saveReturnUrl(window.location.pathname + window.location.search);
                this._openNotification(Labels.errors[401], '', DialogLayoutDisplay.DANGER);
                this._auth.logout();
                this._router.navigateByUrl('/login');
              }
              break;
            case 403:
              // Set static flag to prevent any logout attempts
              HttpErrorInterceptor.hasAccessRestriction = true;
              break;
          }
        }

        // Rule is disabled because no matter what we want to raise the error to he previous interceptor

        return throwError(() => error);
      })
    );
  }

  private _openNotification(title: string, message: string, type: DialogLayoutDisplay) {
    const newToastNotification = new ToastNotificationInitializer();

    newToastNotification.setTitle(message);
    newToastNotification.setMessage(title);

    newToastNotification.setConfig({
      layoutType: type,
      progressBar: ToastProgressBarEnum.NONE,
      toastPosition: ToastPositionEnum.BOTTOM_FULL_WIDTH,
      autoCloseDelay: 5000,
    });

    newToastNotification.openToastNotification$();
  }
}
